import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { demandCreate, getCustomerSale, checkReceiveUser } from '../api/index.js';
import { getBusinessType as _getBusinessType, getSearchCardType } from '@/api/order.js';
import CardDemandMaterialSelectDrawer from './cardDemandMaterialSelectDrawer.vue';
export default {
  name: 'CardDemandApplyDrawer',
  components: {
    CardDemandMaterialSelectDrawer: CardDemandMaterialSelectDrawer
  },
  data: function data() {
    return {
      submitLoading: false,
      loading: false,
      drawerSelect: false,
      businessTypeList: [],
      // 业务类型
      cardTypeList: [],
      // 卡类型
      form: {
        customer_id: '',
        // 客户ID
        sale_user_id: '',
        // 领用人ID
        user_name: '',
        // 领用人
        card_group_type_id: '',
        // 业务类型ID
        card_type: '',
        // 卡类型
        expected_card_date: '',
        // 预计领卡日期
        expected_card_time: '',
        // 预计领卡时间
        note: '',
        // 备注
        material_arr: []
      }
    };
  },
  computed: {
    // 明细中已存在的卡券物料类型（material_type 1：PVC卡 2：券）
    existingCardCouponTypes: function existingCardCouponTypes() {
      return (this.form.material_arr || []).map(function (item) {
        return String(item.material_type);
      }).filter(function (type) {
        return type === '1' || type === '2';
      });
    }
  },
  created: function created() {
    this.getBusinessType();
  },
  methods: {
    // 客户ID失焦，根据客户ID获取领用人
    handleCustomerBlur: function handleCustomerBlur() {
      var _this = this;
      var customerId = String(this.form.customer_id || '').trim();
      this.form.user_name = '';
      if (!customerId || !/^[1-9]\d*$/.test(customerId)) return;
      getCustomerSale({
        customer_id: customerId
      }).then(function (res) {
        _this.form.user_name = res.data && res.data.sale_user_name || '';
      }).catch(function () {
        _this.form.user_name = '';
      });
    },
    // 获取业务类型
    getBusinessType: function getBusinessType() {
      var _this2 = this;
      _getBusinessType().then(function (res) {
        _this2.businessTypeList = res.data;
      });
    },
    // 根据业务类型获取卡类型
    getCardTypeList: function getCardTypeList(businessId, callback) {
      var _this3 = this;
      getSearchCardType({
        version: 2,
        business_id: businessId
      }).then(function (res) {
        _this3.cardTypeList = res.data;
        if (callback) callback();
      });
    },
    // 切换业务类型，联动清空卡类型
    changeBusinessType: function changeBusinessType(val) {
      this.form.card_type = '';
      this.cardTypeList = [];
      if (val) {
        this.getCardTypeList(val);
      }
    },
    // 校验卡/券类型物料数量（material_type 1：PVC卡 2：券，最多1个）
    checkCardMaterialLimit: function checkCardMaterialLimit(items) {
      var count = (items || []).filter(function (item) {
        var type = Number(item.material_type);
        return type === 1 || type === 2;
      }).length;
      if (count > 1) {
        this.$message.error('只能提交1个卡/券类型的物料');
        return false;
      }
      return true;
    },
    // 打开添加物料抽屉
    handleAddMaterial: function handleAddMaterial() {
      this.drawerSelect = true;
    },
    // 添加物料确认回调，追加到明细（已存在的物料不重复添加）
    handleMaterialSelected: function handleMaterialSelected(materials) {
      var existIds = this.form.material_arr.map(function (item) {
        return String(item.id);
      });
      var list = (materials || []).filter(function (item) {
        return !existIds.includes(String(item.id));
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          apply_num: ''
        });
      });
      if (!list.length) {
        this.$message.warning('所选物料均已添加，请勿重复选择');
        return;
      }
      var merged = [].concat(_toConsumableArray(this.form.material_arr), _toConsumableArray(list));
      this.form.material_arr = merged;
      this.drawerSelect = false;
    },
    // 移除物料
    handleRemove: function handleRemove(index) {
      this.form.material_arr.splice(index, 1);
    },
    // 提交
    submitForm: function submitForm() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        if (_this4.form.material_arr.length === 0) {
          _this4.$message.warning('请至少添加一个物料');
          return;
        }
        // 校验必须提交1个卡/券类型的物料（material_type 1：PVC卡 2：券）
        var cardCouponCount = _this4.form.material_arr.filter(function (item) {
          var type = Number(item.material_type);
          return type === 1 || type === 2;
        }).length;
        if (cardCouponCount !== 1) {
          _this4.$message.error('必须提交1个卡/券类型的物料');
          return;
        }
        // 提交前校验领取人与登录人是否一致
        _this4.loading = true;
        checkReceiveUser({
          customer_id: _this4.form.customer_id
        }).then(function (res) {
          var data = res && res.data || {};
          // is_now 为 0 表示不一致，需弹窗确认
          if (Number(data.is_now) === 0) {
            _this4.$confirm("\u5F53\u524D\u9886\u7528\u5355\u3010\u5BA2\u6237ID <span style=\"color:#F56C6C;font-weight:bold\">".concat(data.customer_id, "</span>\u3011 \u5BF9\u5E94\u7684\u7533\u8BF7\u4EBA\u662F\u3010<span style=\"color:#F56C6C;font-weight:bold\">").concat(data.sale_user_name, "</span>\u3011\uFF0C\u786E\u5B9A\u63D0\u4EA4\uFF1F"), '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              dangerouslyUseHTMLString: true
            }).then(function () {
              _this4.doSubmit();
            });
            return;
          }
          // 一致，直接提交
          _this4.doSubmit();
        }).finally(function () {
          _this4.loading = false;
        });
      });
    },
    // 实际提交
    doSubmit: function doSubmit() {
      var _this5 = this;
      if (!this.checkCardMaterialLimit(this.form.material_arr)) return;
      this.submitLoading = true;
      var params = _objectSpread(_objectSpread({}, this.form), {}, {
        material_arr: this.form.material_arr.map(function (item) {
          return {
            id: item.id,
            apply_num: Number(item.apply_num)
          };
        })
      });
      demandCreate(params).then(function () {
        _this5.$message.success('领卡需求登记已提交');
        _this5.$emit('emitGetList');
      }).finally(function () {
        _this5.submitLoading = false;
      });
    },
    handleClose: function handleClose() {
      this.$emit('close');
    }
  }
};